import en from './translations/en';
import sl from './translations/sl';
import hr from './translations/hr';

export default {
	en,
	sl,
	hr
};